import React from 'react';
import { Box } from 'rebass';
import { colors } from '../../tailwind';
import { Text } from './';
import ViewBox from './ViewBox';

function FormBox(props) {
  const { header, children} = props;

  return (
    <ViewBox noPadding noMin>
      <Box bg={colors.offWhite}>
        <Text p={3}>{header}</Text>
      </Box>
      <Box p={4}>{children}</Box>
    </ViewBox>
  );
}

export default FormBox;



// WEBPACK FOOTER //
// ./src/components_new/common/FormBox.js